export default "__VITE_ASSET__CmagyWX8__"